import Icon from "@mui/material/Icon";
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Dashboard from "layouts/dashboard";
import VendorCategory from "layouts/tables/admin/vendor_categories"
import VendorAdminProducts from "layouts/tables/admin/vendor_products";
import Vendororders from "layouts/tables/admin/vendor_order_details";
import Approve from "layouts/tables/admin/vendor_approve";
import SalesReport from "layouts/tables/Reports/sales_report";
import VendorRegister from "layouts/tables/admin/vendor_register/vendor_register";
import Banner from "layouts/tables/admin/banner_content"
import ServiceType from "layouts/tables/admin/services_type/ServiceType";
import ServiceRegistration from "layouts/tables/admin/service_register/service_registration";
import ServiceApprove from "layouts/tables/admin/service_approve/service_approve";
import Swal from 'sweetalert2';
import api from 'core/interceptors/api';
import BusinessCategory from "layouts/tables/admin/business_category/business_category";
import InactiveVendors from "layouts/tables/admin/inactive_vendors/inactive_vendors";

const routesAdmin = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    permissionKey: "dashboard",
  },
  {
    type: "collapse",
    name: "Vendor Management",
    key: "vendor_management",
    icon: <Icon fontSize="small">storefront</Icon>,
    permissionKey: "vendor_management",
    children: [
      {
        type: "collapse",
        name: "Registration",
        key: "vendor_register",
        icon: <Icon fontSize="small">app_registration</Icon>,
        route: "/vendor_management/Registration",
        component: <VendorRegister />,
      },
      {
        type: "collapse",
        name: "Vendor Approve",
        key: "vendor_approve",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/vendor_management/Approve_Request",
        component: <Approve />,
      },
      {
        type: "collapse",
        name: "Inactive Vendors",
        key: "vendor_inactive",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/vendor_management/Inactive_Vendors",
        component: <InactiveVendors />,
      },
      {
        type: "collapse",
        name: "Business Category",
        key: "business_category",
        icon: <Icon fontSize="small">business_center</Icon>,
        route: "/vendor_management/business_category",
        component: <BusinessCategory />,
      },
      {
        type: "collapse",
        name: "Vendor Products",
        key: "vendor_products",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/vendor_management/Vendor_Products",
        component: <VendorAdminProducts />,
      },
      {
        type: "collapse",
        name: "Vendor Categories",
        key: "vendor_categories",
        icon: <Icon fontSize="small">category_search</Icon>,
        route: "/vendor_management/Vendor_Categories",
        component: <VendorCategory />,
      },
      {
        type: "collapse",
        name: "Vendor Orders",
        key: "vendor_orders",
        icon: <Icon fontSize="small">reorder</Icon>,
        route: "/vendor_management/Order_Details",
        component: <Vendororders />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Service Management",
    key: "service_management",
    icon: <Icon fontSize="small">local_mall</Icon>,
    permissionKey: "service_management",
    children: [
      {
        type: "collapse",
        name: "Registration",
        key: "service_register",
        icon: <Icon fontSize="small">app_registration</Icon>,
        route: "/service_management/Registration",
        component: <ServiceRegistration />,
      },
      {
        type: "collapse",
        name: "Service Approve",
        key: "service_approve",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/service_management/service_approve",
        component: <ServiceApprove />,
      },
      {
        type: "collapse",
        name: "Service Type",
        key: "service_type",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/service_management/service_type",
        component: <ServiceType />,
      },
      {
        type: "collapse",
        name: "Service Specialization",
        key: "service_specialization",
        icon: <Icon fontSize="small">apps</Icon>,
        route: "/service_management/service_specialization",
        component: <ServiceType />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports and Analyzes",
    key: "report_analytics",
    icon: <Icon fontSize="small">monitoring</Icon>,
    permissionKey: "report_analytics",
    children: [
      {
        type: "collapse",
        name: "Sales Report",
        key: "admin_sales_report",
        icon: <Icon fontSize="small">bar_chart</Icon>,
        route: "/report_management/sales_reports",
        component: <SalesReport />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    permissionKey: "settings",
    children: [
      {
        type: "collapse",
        name: "Banner",
        key: "banner",
        icon: <Icon fontSize="small">image</Icon>,
        route: "/admins/banner_content",
        component: <Banner />,
      },
    ],
  },
];

export default routesAdmin;
const routesMarketingManager = routesAdmin;
const routesTelecaller = routesAdmin;

export const fetchAndFilterRoutesMM = async (email) => {
  try {
    const res = await api.get(`/marketing_manager/get_permissions?email=${email}`);
    const permissions = res.data.permissions;

    console.log("MM Permissions fetched:", permissions);

    const filterRoutes = (routes) =>
      routes
        .map((route) => {
          if (route.children) {
            const filteredChildren = route.children.filter((child) =>
              permissions[child.key?.replace(/\s+/g, "_").toLowerCase()]
            );

            if (
              permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ||
              filteredChildren.length > 0
            ) {
              return {
                ...route,
                children: filteredChildren,
              };
            }
            return null;
          }

          return permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ? route : null;
        })
        .filter(Boolean);

    const filteredRoutes = filterRoutes(routesMarketingManager);
    console.log("Filtered MM Routes:", filteredRoutes);
    return filteredRoutes;
  } catch (error) {
    console.error("Error fetching MM permissions:", error);
    Swal.fire("Error", "Failed to load marketing manager permissions", "error");
    return [];
  }
};
export const fetchAndFilterRoutesTC = async (email) => {
  try {
    const res = await api.get(`/telecaller/get_permissions?email=${email}`);
    const permissions = res.data.permissions;

    console.log("Telecaller Permissions fetched:", permissions);

    const filterRoutes = (routes) =>
      routes
        .map((route) => {
          if (route.children) {
            const filteredChildren = route.children.filter((child) =>
              permissions[child.key?.replace(/\s+/g, "_").toLowerCase()]
            );

            if (
              permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ||
              filteredChildren.length > 0
            ) {
              return {
                ...route,
                children: filteredChildren,
              };
            }
            return null;
          }

          return permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ? route : null;
        })
        .filter(Boolean);

    const filteredRoutes = filterRoutes(routesTelecaller);
    console.log("Filtered Telecaller Routes:", filteredRoutes);
    return filteredRoutes;
  } catch (error) {
    console.error("Error fetching Telecaller permissions:", error);
    Swal.fire("Error", "Failed to load telecaller permissions", "error");
    return [];
  }
};

export const fetchAndFilterRoutesAdmin = async (vendorEmail) => {
  try {
    const res = await api.get(`/admin_controller/get_permissions?email=${vendorEmail}`);
    const permissions = res.data.permissions;

    console.log("Permissions fetched successfully:", permissions);

    const filterRoutes = (routes) =>
      routes
        .map((route) => {
          if (route.children) {
            const filteredChildren = route.children.filter((child) =>
              permissions[child.key?.replace(/\s+/g, "_").toLowerCase()]
            );

            // Show parent if it has permission or any of its children
            if (
              permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ||
              filteredChildren.length > 0
            ) {
              return {
                ...route,
                children: filteredChildren,
              };
            }
            return null;
          }

          return permissions[route.permissionKey?.replace(/\s+/g, "_").toLowerCase()] ? route : null;
        })
        .filter(Boolean); // Remove nulls

    const filteredRoutes = filterRoutes(routesAdmin);
    console.log("Filtered Routes:", filteredRoutes);
    return filteredRoutes;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    Swal.fire("Error", "Failed to load permissions", "error");
    return [];
  }
};

